<template>
    <!-- List Contacts Page -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center mt-2 mb-4">
                <div class="breadcrumbnew">
                    <span>Leads</span>
                    <a>List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center">
                    <button class="btn btn-new-primary btn-wide px-6 ml-4" @click="$modal.show('columnConfigCampaigns')"><img src="/static/images/column-config.svg" style="margin-right: 8px; margin-top: -2px"> Column Config</button>
                    <button class="btn btn-new-primary btn-wide px-6 ml-4"><img src="/static/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                    <button class="btn btn-new-primary btn-wide px-6 ml-4"><img src="/static/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px"> Export to Excel</button>
                    <button class="btn btn-new-danger btn-wide px-6 ml-4">- Delete</button>
                    <button class="btn btn-new-green btn-wide px-6 ml-4" @click="$router.push('/createCampaign')">+ Create New</button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex mx-4" style="flex-grow: 1">
                        <i class="icon icon-magnify icondefault" style="border-radius: 20px 0px 0px 20px; padding: 8px 16px; height: 2.7em;"></i>
                        <input class="w-100" type="text" v-model="search_key" placeholder="Search by Lead Contact Name, Lead Source, Product Interest" style="border-radius: 0px 20px 20px 0px; padding-left: 10px; height: 2.9em;">
                    </div>
                    <el-dropdown trigger="click" class="type-select">
                        <span class="el-dropdown-link d-flex justify-content-between w-100 px-3">
                            {{ campaignsToShow }} <img src="/static/images/down-arrow-grey-full.svg" style="margin-right: 10px;">
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="campaignsToShow = 'Completed'">Completed</el-dropdown-item>
                            <el-dropdown-item @click.native="campaignsToShow = 'Draft'">Draft</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div v-if="campaignsToShowStyle == 'list' && campaigns.length" class="bg-white" style="height: 2.5em"></div>
            <div v-if="campaignsToShowStyle == 'list'" class="table-block" style="overflow: auto">
                <table class="team-list-table w-100">
                    <thead>
                        <tr>
                            <th>
                                <label v-if="campaignsToShow == 'Draft'" class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" />
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th></th>
                            <th v-for="(column,index) in columnConifg" :key="index">
                                {{ column.value }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="ajaxCallinprogress">
                            <td colspan="10">
                                <div class="d-flex align-items-center justify-content-center h-100">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-if="!campaigns.length && !ajaxCallinprogress">
                            <td colspan="10">
                                <div>
                                    <div class="d-flex justify-content-center align-items-center py-8" style="background: #fff; border-radius: 5px">
                                        <span class="fw-600 fs-18">No Campaigns Found</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-for="(campaign, index) in campaigns" :key="index">
                            <td>
                                <div v-if="campaignsToShow == 'Completed'" class="pointer">
                                    <el-tooltip class="item" effect="dark" content="View" placement="top">
                                        <button class="btn-icon pt-3 pointer" style="padding:0px!important;">
                                            <i class="icon icon-eye eyeIcon item text-dark iconsize-18" style="margin-right: 13px;"></i>
                                        </button>
                                    </el-tooltip>
                                </div>
                                <label v-if="campaignsToShow == 'Draft'" class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" />
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td>
                                <div v-if="campaignsToShow == 'Completed'" class="pointer">
                                    <el-tooltip class="item" effect="dark" content="Copy" placement="top">
                                        <button class="btn-icon pt-3 pointer" style="padding:0px!important;">
                                            <img src="/static/images/copy-yellow.svg" height="15px;">
                                        </button>
                                    </el-tooltip>
                                </div>
                                <div v-if="campaignsToShow == 'Draft'" class="pointer">
                                    <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                        <button class="pointer btn-icon pt-3" style="padding:0px!important;">
                                            <img src="/static/images/edit.svg" height="15px;">
                                        </button>
                                    </el-tooltip>
                                </div>
                            </td>
                            <td>
                                {{ campaign.name || "-" }}
                            </td>
                            <td>
                                {{ campaign.campaign_owner || "-" }}
                            </td>
                            <td>
                                {{ campaign.campaign_type || "-" }}
                            </td>
                            <td>
                                {{ campaign.campaign_status || "-" }}
                            </td>
                            <td>
                                {{ campaign.date || "-" }}
                            </td>
                            <td>
                                {{ campaign.product || "-" }}
                            </td>
                            <td v-if="columnConifg.length > 6">
                                <span v-if="columnConifg[6].value == 'Campaign Budget'">{{ "-" }}</span>
                                <span v-if="columnConifg[6].value == 'Location'">{{ campaign.location.country || "-" }}</span>
                                <span v-if="columnConifg[6].value == 'Social Media Type'">{{ campaign.social_media_type || "-" }}</span>
                            </td>
                            <td v-if="columnConifg.length > 7">
                                <span v-if="columnConifg[7].value == 'Campaign Budget'">{{ "-" }}</span>
                                <span v-if="columnConifg[7].value == 'Location'">{{ campaign.location.country || "-" }}</span>
                                <span v-if="columnConifg[7].value == 'Social Media Type'">{{ campaign.social_media_type || "-" }}</span>
                            </td>
                            <td v-if="columnConifg.length > 8">
                                <span v-if="columnConifg[8].value == 'Campaign Budget'">{{ "-" }}</span>
                                <span v-if="columnConifg[8].value == 'Location'">{{ campaign.location.country || "-" }}</span>
                                <span v-if="columnConifg[8].value == 'Social Media Type'">{{ campaign.social_media_type || "-" }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="campaignsToShowStyle == 'list' && campaigns.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <input class="text-center" type="text" v-model.number="limit" onkeypress="return event.charCode >= 48 && event.charCode <= 57" @input="getCampaigns" style="min-height: 30px; width: 46px; border: solid 2px rgba(103, 103, 103, 0.84); border-radius: 5px; padding-right: 22px;" />
                <img src="/static/images/down-arrow-grey.svg" style="margin-left: -20px;">
                <span class="page-info pr-2 pl-6 fw-500" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
                <span class="forwardBackward ml-8">
                    <i class="icon-chevron-double-left"></i>
                </span>
                <span class="forwardBackward ml-2">
                    <i class="icon-chevron-left"></i>
                </span>
                <span class="page-info px-2 fw-500" style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Showing {{ start }} - {{ end }} of {{ total }}</span>
                <span class="forwardBackward ml-1">
                    <i class="icon-chevron-right"></i>
                </span>
                <span class="forwardBackward ml-2">
                    <i class="icon-chevron-double-right"></i>
                </span>
            </div>
        </div>
        <column-config-campaigns modal_name="columnConfigCampaigns" @coloumnUpdateCampaign="getCampaigns()"></column-config-campaigns>
    </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import ColumnConfigCampaigns from "./ColumnConfigCampaigns";
export default {
    data() {
        return {
            ajaxCallinprogress: false,
            count: 0,
            limit: 10,
            start: 0,
            end: 0,
            total: 0,
            search_key: "",
            campaignsToShow: "Completed",
            campaignsToShowStyle: "list",
            campaigns: [],
            columnConifg: [],
        }
    },
    components: {
        HalfCircleSpinner,
        ColumnConfigCampaigns,
    },
    methods: {
        async getCampaigns() {
            this.ajaxCallinprogress = true;
            let params = {
                skip: this.count * this.limit,
                limit: this.limit,
                search_key: this.search_key,
                filter_json: {},
            }
            let res = await this.$http.post("/campaign/list_view", params);
            if (res.data.status_id == 1) {
                this.campaigns = res.data.response;
                this.ajaxCallinprogress = false;
            }
        },
        async getColumnConfig() {
            let res = await this.$http.get("/user_column_config/?category=campaigns");
            if (res.data.status_id == 1) {
                this.columnConifg = res.data.response.campaigns;
                // console.log(this.columnConifg)
            }
        },
    },
    created() {
        this.getCampaigns();
        this.getColumnConfig();
    },
    watch: {
        search_key: function() {
            this.getCampaigns();
        },
        // campaignsToShow: function() {
        //     this.getCampaigns();
        // },
    },
}
</script>

<style scoped>
    .team-list-table thead tr th {
        background: #005dae;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 13px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .type-select {
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
        width: 12em;
    }
    .arrow-right {
        width: 0;
        height: 0;
        border-top: 14px solid transparent;
        border-bottom: 14px solid transparent;
        border-right: 14px solid #fff;
    }
    .filter-div {
        position: fixed;
        top: 22em;
        right: 3em;
        width: 50em;
        border-radius: 7.5px;
        z-index: 9999;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListCampaign.vue